<div class="classroom-materials-section">
    <h2 [ngClass]="gradeClass" class="english">Classroom Materials</h2>
    <h2 [ngClass]="gradeClass" class="spanish hidden">Materiales para la clase</h2>

    <!-- INTRO ENGLISH -->
    <div class="infoBlock english">
        <p>You may download and copy any of these materials for use
            in your classroom. <strong>There is no
            charge to use these materials</strong>. Some items
            can be personalized: On the job offer form,
            for example, you can fill in the blanks onscreen and
            print an individual offer for each of your
            students.</p>
        <p>You may need to turn off your pop-up blocker to open
            these forms.</p>
        <p>Adobe Reader is required to view certain documents
            online. If you don't have it, you can download it
            free of charge from Adobe's website. On the <a
            href="http://www.adobe.com" target="_blank" aria-label="Adobe homepage. Opens in a new tab" class="c11n-link c11n-link--primary c11n-link--reinforced"><span class="c11n-link__content">Adobe
            homepage</span></a>, you will find a section labeled
            "Download" that contains a link for Adobe Reader
        </p>
        <p>If your school lacks the resources to print or copy
            materials from this site, you may order copies
            from us. Vanguard will mail you individual items you
            choose or the complete kit for the grade you
            teach.</p>
    </div>

    <!-- INTRO SPANISH -->
    <div class="infoBlock spanish hidden">
        <p>Puede descargar y copiar cualquiera de estos materiales
            para usar en su clase. <strong>No hay ningún
            costo por usar estos materiales</strong>. Algunos
            elementos se pueden personalizar: en el
            formulario de oferta de trabajo, por ejemplo, puede
            completar los espacios en blanco e imprimir una
            oferta individual para cada uno de sus alumnos.</p>
        <p>Es posible que deba desactivar su bloqueador de elementos
            emergentes para abrir estos formularios.</p>
        <p>Se requiere Adobe Reader para ver ciertos documentos en
            línea. Si no lo tiene, puede descargarlo sin
            costo desde el sitio web de Adobe. <a
            href="http://www.adobe.com" target="_blank" aria-label="Página de inicio de Adobe. Se abre en una nueva pestaña" class="c11n-link c11n-link--primary c11n-link--reinforced"><span class="c11n-link__content">En la
            página de inicio de Adobe</span></a>, encontrará una sección titulada
            "Descargar" que contiene un enlace para Adobe Reader.</p>
        <p>Si su escuela no cuenta con los recursos para imprimir o
            copiar materiales de este sitio de la web,
            puede solicitar copias a nosotros. Vanguard le enviará
            por correo los artículos individuales que
            elija o el kit completo para el grado que usted enseñe.</p>
    </div>

    <div class="simulator">
        <c11n-button
        class="globalButton page-button"
        [labelText]="orderButtonLabel"
        [size]="'large'"
        buttonType="button"
        (clickEvent)="navigateToOrderMaterials()">
        </c11n-button>
    </div>

    <!-- MATERIALS LIST ENGLISH -->
    <div class="infoBlock english" *ngIf="materials">
        <ng-container *ngFor="let category of materials.categories">
            <h3>{{ category.headingEn }}</h3>
            <div>
                <div class="materials-row" *ngFor="let item of category.items">
                    <p [id]="item.id">{{ item.labelEn }}
                        <sub *ngIf="item.subLabelEn">({{ item.subLabelEn }})</sub>
                    </p>
                    <div class="icon">
                        <button type="button"
                           (click)="modalService.openMaterialsForm($event, item.filePath)"
                           [attr.aria-labelledby]="item.id">
                            <img [src]="getIconSrc(item.iconType)"
                                 [title]="getIconTitle(item.iconType)"
                                 [alt]="getIconAlt(item.iconType)">
                        </button>
                    </div>
                </div>
            </div>
        </ng-container>

        <h3>{{ materials.supplies.headingEn }}</h3>
        <div>
            <div class="materials-row" *ngFor="let supply of materials.supplies.items">
                <p>{{ supply.labelEn }}</p>
            </div>
        </div>
    </div>

    <!-- MATERIALS LIST SPANISH -->
    <div class="infoBlock spanish hidden" *ngIf="materials">
        <ng-container *ngFor="let category of materials.categories">
            <h3>{{ category.headingEs }}</h3>
            <div>
                <div class="materials-row" *ngFor="let item of category.items">
                    <p [id]="item.id + '-es'">{{ item.labelEs }}
                        <sub *ngIf="item.subLabelEs">({{ item.subLabelEs }})</sub>
                    </p>
                    <div class="icon">
                        <button type="button"
                           (click)="modalService.openMaterialsForm($event, item.filePathEs)"
                           [attr.aria-labelledby]="item.id + '-es'">
                            <img [src]="getIconSrc(item.iconType)"
                                 [title]="getIconTitle(item.iconType)"
                                 [alt]="getIconAlt(item.iconType)">
                        </button>
                    </div>
                </div>
            </div>
        </ng-container>

        <h3>{{ materials.supplies.headingEs }}</h3>
        <div>
            <div class="materials-row" *ngFor="let supply of materials.supplies.items">
                <p>{{ supply.labelEs }}</p>
            </div>
        </div>
    </div>
</div>
